// 是否微信平台
const isWeixin = () => {
    const ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') return true
    return false
}

module.exports = {
    isWeixin: isWeixin(),
}